<template>
    <div class="main">
        <el-form label-position="top">
            <el-tabs type="border-card" v-model="tabAtivo">
                <el-tab-pane label="FILTROS" name="filtros">

                    <!-- Instituição / Período -->
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="18">
                            <el-form-item label="Instituição" key="instituicao" v-if="ehSmed">
                                <el-select @change="onChangeInstituicao" v-model="filtro.instituicao_id" filterable placeholder="- TODAS AS INSTITUIÇÕES -" clearable style="width: 100%;">
                                    <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <div class="style-form" v-else>
                                <label>Instituição</label>
                                <div class="style-input readonly">{{ $store.state.config.instituicao ? $store.state.config.instituicao.nome : '' }}</div>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="6">
                            <el-form-item label="Período">
                                <el-select @change="getTurmas()" v-model="filtro.periodo_letivo_id" style="width: 100%;">
                                    <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- Turma / Tipo de ocorrência -->
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Turma (opcional)">
                                <el-select v-model="filtro.turma_id" clearable filterable placeholder="Todas" style="width: 100%;">
                                    <el-option-group v-for="(grupo, i) in turmas" :key="i" :label="i">
                                        <el-option v-for="t in grupo" :key="t.id" :label="`${t.curso.nome} ${t.nome}`" :value="t.id"></el-option>
                                    </el-option-group>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Tipo de Ocorrência (opcional)">
                                <el-select v-model="filtro.tipo_ocorrencia_id" clearable filterable placeholder="Todos" style="width: 100%;">
                                    <el-option v-for="t in tipos" :key="t.id" :label="t.nome" :value="t.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- Aluno -->
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24">
                            <el-form-item label="Aluno (opcional)">
                                <el-select v-model="filtro.aluno_id" filterable remote clearable :remote-method="buscarAlunos" :loading="loadingAlunos" placeholder="Pesquisar aluno" style="width: 100%;">
                                    <el-option v-for="a in alunosBusca" :key="a.id" :label="a.nome" :value="a.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- Intervalo de datas -->
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Data inicial (opcional)">
                                <el-date-picker v-model="filtro.data_inicio" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Início" style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Data final (opcional)">
                                <el-date-picker v-model="filtro.data_fim" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Fim" style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-tab-pane>
            </el-tabs>

            <div class="u-mt-10">
                <el-row>
                    <el-col :xs="24" :sm="24" class="u-text-right">
                        <el-button @click="gerar()" type="primary">
                            <i class="el-icon-printer"></i> GERAR PDF
                        </el-button>
                    </el-col>
                </el-row>
            </div>
        </el-form>
    </div>
</template>

<script>
export default {
    data: () => ({
        tabAtivo: 'filtros',
        loadingAlunos: false,
        filtro: {
            instituicao_id: '',
            periodo_letivo_id: '',
            turma_id: '',
            tipo_ocorrencia_id: '',
            aluno_id: '',
            data_inicio: '',
            data_fim: ''
        },
        turmas: [],
        tipos: [],
        alunosBusca: []
    }),
    computed: {
        ehSmed () {
            const t = this.$store.state.user.tipo
            return t == 10 || (t > 3 && t <= 8)
        }
    },
    mounted () {
        this.filtro.periodo_letivo_id = this.$store.state.config.parametros.periodo_letivo_situacao_academica

        if (!this.ehSmed && this.$store.state.config.instituicao) {
            this.filtro.instituicao_id = this.$store.state.config.instituicao.id
        }

        this.carregarTipos()
        this.getTurmas()
    },
    methods: {
        carregarTipos () {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/ocorrencia/getTiposOcorrencia`, this.$store.getters.getHeaderAuth)
                .then(r => { this.tipos = Array.isArray(r.data) ? r.data : [] })
                .catch(e => this.$store.commit('throwException', e))
        },

        onChangeInstituicao () {
            this.filtro.turma_id = ''
            this.getTurmas()
        },

        getTurmas () {
            this.filtro.turma_id = ''
            this.turmas = []

            if (!this.filtro.instituicao_id || !this.filtro.periodo_letivo_id) return

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getTurmasForListDiario/${this.filtro.instituicao_id}/${this.filtro.periodo_letivo_id}`, this.$store.getters.getHeaderAuth).then(response => {
                this.turmas = response.data
            }).catch(error => { this.$store.commit('throwException', error) })
        },

        buscarAlunos (query) {
            if (!query || query.length < 3) { this.alunosBusca = []; return }
            this.loadingAlunos = true
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/ocorrencia/searchAlunos`, { query }, this.$store.getters.getHeaderAuth)
                .then(r => { this.alunosBusca = Array.isArray(r.data) ? r.data : []; this.loadingAlunos = false })
                .catch(e => { this.loadingAlunos = false; this.$store.commit('throwException', e) })
        },

        gerar () {
            if (this.ehSmed && !this.filtro.instituicao_id && !this.filtro.turma_id && !this.filtro.aluno_id) {
                window.eventBus.$emit('alert', { msg: 'Selecione ao menos a instituição, a turma ou o aluno.', type: 'warning' })
                return
            }

            window.eventBus.$emit('print', {
                url: '/api/ocorrencia/imprimir',
                param: {
                    instituicao_id: this.filtro.instituicao_id || '',
                    turma_id: this.filtro.turma_id || '',
                    tipo_ocorrencia_id: this.filtro.tipo_ocorrencia_id || '',
                    aluno_id: this.filtro.aluno_id || '',
                    data_inicio: this.filtro.data_inicio || '',
                    data_fim: this.filtro.data_fim || '',
                    periodo_letivo_id: this.filtro.periodo_letivo_id || ''
                }
            })
        }
    }
}
</script>
